export enum DocumentType {
  LegalNameChange = 'Legal name change',
  PurchaseOrder = 'Purchase Order',
}
